import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { InfoPage } from "@/components/InfoPage";

const SectionTitle = ({ children }) => (
  <h2 className="text-crew-yellow text-base md:text-lg font-bold uppercase tracking-tight pt-4">{children}</h2>
);

export default function About() {
  return (
    <InfoPage eyebrow="Verso Studios at The Westport Library" title="About Crew Call" testId="about-page">
      <p className="text-white text-base sm:text-lg font-semibold">
        Thank you for your interest in the Video Production Crew Call program, offered by Verso Studios at The Westport Library!
      </p>
      <p>We’d love to help you learn about the program and see if it would be a good fit for you.</p>

      <SectionTitle>A few words about our Crew Call program</SectionTitle>
      <p>
        Crew Call is where we train people in our set-up and system of live-performance coverage and on-stage video production.
      </p>
      <p>
        The program provides the opportunity for our community to participate in the production of many and varied high-profile
        events held at the Library. Although we don’t depend upon this participation, it is a wonderful opportunity to provide
        interested community members hands-on equipment experience and training, fulfilling our commitment to create content by
        the community, for the community — and to share it with the world.
      </p>
      <blockquote className="border-l-4 border-crew-yellow pl-5 text-white">
        We expressly don’t use the word "volunteer." With Crew Call, you're more than that. This program is an opportunity to be
        part of something special, and Crew Call is a reflection of our commitment to making this opportunity available to the
        community. You're doing real work and experiencing real hands-on training that helps us record and distribute first-rate
        programming that offers a first-rate viewing experience for our patrons.
      </blockquote>
      <p>
        Working with Crew Call is a lot of fun and is endlessly interesting work. You get to work with and record fabulous
        performers, talent and thought leaders.
      </p>
      <p>
        Crew Call is first and foremost rewarding for its participants, who are a mix of ages and backgrounds. We see that through
        how many have continued with us over the years. In fact, a great many members of our current Crew Call team have been with
        us since we started the program in 2021.
      </p>
      <p>
        Generally speaking, we'll meet at least an hour ahead of the program so we can meet with you and have you ready to be part
        of the crew right from the get-go!
      </p>
      <div className="pt-6">
        <Link to="/register" data-testid="about-apply-btn">
          <Button className="bg-crew-yellow text-black hover:bg-white font-bold uppercase rounded-sm px-8 py-6 transition-colors">
            Apply to Crew Call
          </Button>
        </Link>
      </div>
    </InfoPage>
  );
}
